(function () {
  function lockScroll() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    var scrollY = Math.abs(parseInt(document.body.style.top || '0', 10));
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function getPopup() {
    return document.querySelector('product-info #PBFPopup');
  }

  function getFinanceButton() {
    return document.querySelector('product-info #PBFPopup .pbf-finance-widget-button');
  }

  // Detect if widget exists on this product page
  function hasNovunaWidget() {
    // finance button is the most reliable signal in your code
    if (getFinanceButton()) return true;

    // fallback signals (in case button differs)
    if (document.querySelector('product-info #PBFPopup .pbf-finance-widget-calculator')) return true;
    if (document.querySelector('product-info #PBFPopup [class*="pbf-finance-widget"]')) return true;

    return false;
  }

  function hidePopupOnLoad() {
    var popup = getPopup();
    if (!popup) return;
    popup.style.display = 'none';
  }

  function ensurePopupEnhancements() {
    var popup = getPopup();
    if (!popup) return;

    if (!popup.querySelector('.PBFPopup--bg')) {
      popup.insertAdjacentHTML('beforeend', '<div class="PBFPopup--bg" data-novuna-close></div>');
    }

    var calc = popup.querySelector('.pbf-finance-widget-calculator');
    var template = document.getElementById('fw-finance-modal-shell');
    if (calc && template && !popup.querySelector('.fw-finance-dialog')) {
      popup.appendChild(template.content.cloneNode(true));
      popup.querySelector('[data-novuna-calculator-slot]').appendChild(calc);
      var heading = calc.querySelector('.pbf-popup-heading h2');
      var value = calc.querySelector('#pbf-financeable-value');
      if (heading && value) heading.replaceChildren(document.createTextNode('Purchase price'), value);
      var saveLabel = calc.querySelector('#pbf-save-button > span');
      if (saveLabel) saveLabel.textContent = 'Continue with Novuna';
      var summaryBody = calc.querySelector('.pbf-summary tbody');
      if (summaryBody) summaryBody.insertAdjacentHTML('afterbegin', '<tr><td>Deposit</td><td style="text-align:right" data-novuna-summary-deposit></td></tr>');
      var summaryTerm = calc.querySelector('#summary-pbf-term');
      if (summaryTerm) {
        summaryTerm.parentElement.replaceChildren(document.createTextNode('Monthly payments ('), summaryTerm, document.createTextNode(' months)'));
      }
      var monthlyValue = calc.querySelector('#pbf-monthly-payment');
      if (monthlyValue) monthlyValue.insertAdjacentHTML('afterend', '<span data-novuna-payment-count></span>');
      var depositField = calc.querySelector('.pbf-fieldset-deposit');
      if (depositField) depositField.insertAdjacentHTML('beforeend', '<output class="fw-deposit-percent" aria-label="Selected deposit percentage" data-novuna-deposit-percent></output>');
    }
    updateTermCaptions();
    updateFinanceSummary();
    var summaryDeposit = popup.querySelector('[data-novuna-summary-deposit]');
    var depositValue = popup.querySelector('#pbf-deposit-value');
    if (summaryDeposit && depositValue) summaryDeposit.textContent = depositValue.textContent;
  }

  function updateFinanceSummary() {
    var popup = getPopup();
    if (!popup || !popup.querySelector('.fw-finance-dialog')) return;
    function mirror(sourceSelector, targetSelector, prefix, suffix) {
      var source = popup.querySelector(sourceSelector), target = popup.querySelector(targetSelector);
      if (!source || !target) return;
      var text = prefix + source.textContent.trim() + suffix;
      if (target.textContent !== text) target.textContent = text;
    }
    mirror('#summary-pbf-term', '[data-novuna-payment-count]', ' × ', '');
    mirror('#pbf-deposit', '[data-novuna-deposit-percent]', '', '%');
    var apr = popup.querySelector('#pbf-apr');
    if (apr && apr.closest('tr')) apr.closest('tr').classList.toggle('fw-zero-apr', apr.textContent.trim() !== '' && Number(apr.textContent) === 0);
  }

  function updateTermCaptions() {
    var popup = getPopup();
    if (!popup || !popup.querySelector('.fw-finance-dialog')) return;
    var apr = popup.querySelector('#pbf-apr');
    var caption = apr && apr.textContent.trim() !== '' && Number(apr.textContent) === 0 ? 'Interest free' : '';
    popup.querySelectorAll('#pbf-termField label').forEach(function (label) {
      var text = label.querySelector('.fw-term-caption');
      if (!text && caption) {
        text = document.createElement('span');
        text.className = 'fw-term-caption';
        label.appendChild(text);
      }
      if (text && text.textContent !== caption) text.textContent = caption;
    });
  }

  var financeOpener;

  function openNovuna() {
    // hard gate: do nothing if widget not present
    if (!document.body.classList.contains('hasNovunaWidget')) return;

    ensurePopupEnhancements();

    var financeBtn = getFinanceButton();
    if (financeBtn) financeBtn.click();

    document.body.classList.add('FactoryNovuna', 'isNovuaOpen');
    lockScroll();
    financeOpener = document.activeElement;
    var closeButton = getPopup().querySelector('button[data-novuna-close]');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function closeNovuna() {
    if (!document.body.classList.contains('hasNovunaWidget')) return;

    var financeBtn = getFinanceButton();
    if (financeBtn) financeBtn.click();

    document.body.classList.remove('isNovuaOpen');

    var popup = getPopup();
    if (popup) popup.style.display = 'none';

    unlockScroll();
    if (financeOpener && financeOpener.isConnected) financeOpener.focus({ preventScroll: true });
  }

  var bound = false;
  function bind() {
    if (bound) return;
    bound = true;

    document.addEventListener('keydown', function (e) {
      if (!document.body.classList.contains('isNovuaOpen')) return;
      if (e.key === 'Escape') { e.preventDefault(); closeNovuna(); }
      if (e.key !== 'Tab') return;
      var items = Array.from(getPopup().querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')).filter(function (el) {
        return !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
      });
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-novuna-trigger]');
      if (trigger) {
        e.preventDefault();
        openNovuna();
        return;
      }

      var closer = e.target.closest('[data-novuna-close]');
      if (closer) {
        e.preventDefault();
        closeNovuna();
        return;
      }
    });
  }

  function markCTAsVisible() {
    document.body.classList.add('hasNovunaWidget');
  }

  var defaultedFinancePopups = new WeakSet();

  // Read the provider's repayment quote, including its deposit and rounding.
  // Never substitute a price / term estimate when finance is unavailable.
  function updatePriceFinance() {
    var popup = getPopup();
    var product = popup && popup.closest('product-info');
    if (!product) return;
    var price = product.querySelector('.pmd-price');
    if (!price) return;
    var quote = product.querySelector('[data-novuna-price]');
    if (!quote) {
      quote = document.createElement('div');
      quote.className = 'novuna-price';
      quote.setAttribute('data-novuna-price', '');
      quote.hidden = true;
      quote.innerHTML = '<button type="button" data-novuna-trigger><strong data-novuna-monthly></strong> with Novuna <span>View options</span></button><small data-novuna-terms></small><small>Credit subject to status and affordability. Terms apply.</small>';
      price.insertAdjacentElement('afterend', quote);
    }
    function read(selector) {
      var element = popup.querySelector(selector);
      return element ? element.textContent.trim() : '';
    }
    function amount(text) {
      return Number(text.replace(/[^0-9.]/g, ''));
    }
    var monthly = read('#pbf-monthly-payment');
    var term = read('#summary-pbf-term');
    var deposit = read('#pbf-deposit-value');
    var apr = read('#pbf-apr');
    updateFinanceSummary();
    var displayedPrice = price.querySelector('.price--on-sale .price-item--sale') || price.querySelector('.price__regular .price-item--regular');
    var valid = displayedPrice && amount(monthly) > 0 && Number(term) > 0 && deposit && apr &&
      Math.abs(amount(displayedPrice.textContent) - amount(read('#pbf-financeable-value'))) < 0.01 &&
      !read('#pbf-message');
    // Select the provider's available interest-free 10-month term once.
    // Later changes made by the customer must remain selected.
    var tenMonthOption = popup.querySelector('input[name="radio-pbf-term"][value="10"]');
    if (valid && Number(apr) === 0 && tenMonthOption && !tenMonthOption.disabled && !defaultedFinancePopups.has(popup)) {
      defaultedFinancePopups.add(popup);
      if (Number(term) !== 10) {
        tenMonthOption.click();
        return;
      }
    }
    if (quote.hidden === !!valid) quote.hidden = !valid;
    if (!valid) return;
    updateTermCaptions();
    var summaryDeposit = popup.querySelector('[data-novuna-summary-deposit]');
    if (summaryDeposit && summaryDeposit.textContent !== deposit) summaryDeposit.textContent = deposit;
    var monthlyText = monthly + '/month';
    var termsText = term + ' monthly payments · ' + deposit + ' deposit · ' + apr + '% APR';
    var heading = quote.querySelector('[data-novuna-monthly]');
    var terms = quote.querySelector('[data-novuna-terms]');
    if (heading.textContent !== monthlyText) heading.textContent = monthlyText;
    if (terms.textContent !== termsText) terms.textContent = termsText;
  }

  var priceObserver;
  function watchPriceFinance() {
    if (priceObserver) priceObserver.disconnect();
    var product = document.querySelector('product-info');
    if (!product) return;
    priceObserver = new MutationObserver(updatePriceFinance);
    priceObserver.observe(product, { childList: true, subtree: true, characterData: true });
    updatePriceFinance();
  }

  function init() {
    document.body.classList.add('FactoryNovuna');
    hidePopupOnLoad();
    watchPriceFinance();

    // If widget is already there, enable immediately
    if (hasNovunaWidget()) {
      markCTAsVisible();
      return;
    }

    // If widget injects late, poll a few times then stop
    var tries = 0;
    var maxTries = 20; // ~10s at 500ms
    var timer = setInterval(function () {
      tries++;
      hidePopupOnLoad();

      if (hasNovunaWidget()) {
        markCTAsVisible();
        clearInterval(timer);
      }

      if (tries >= maxTries) clearInterval(timer);
    }, 500);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    bind();
  });

  document.addEventListener('shopify:section:load', function () {
    init();
    bind();
  });
})();
